import { render, staticRenderFns } from "./configUserMenuDialog.vue?vue&type=template&id=406ec60e&"
import script from "./configUserMenuDialog.vue?vue&type=script&lang=js&"
export * from "./configUserMenuDialog.vue?vue&type=script&lang=js&"
import style0 from "./configUserMenuDialog.vue?vue&type=style&index=0&id=406ec60e&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports